import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

export default class BlogCategories extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    noticolor: "success",
    redirect: false,
  };

  componentDidMount() {
    this.getAllLevels();
  }

  getAllLevels = () => {
    if (init() === "success") {
      axios
        .get(Constants.getUrls.getAllBlogCategories)
        .then((resp) => {
          if (resp.data.status === "success" && Array.isArray(resp.data.data)) {
            this.setState({
              allJobs: resp.data.data,
            });
          } else {
            this.setState({
              allJobs: [],
            });
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.data?.message || "Failed to load categories",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      this.setState({ redirect: true });
    }
  };

  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteBlogCategory + id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState(
              {
                notification: true,
                noticolor: "success",
                message: resp.data.message,
              },
              () => {
                this.getAllLevels(); // ✅ Corrected function call
              }
            );

            setTimeout(() => {
              this.setState({ notification: false, message: "" });
            }, 2500);
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.data?.message || "Delete failed",
          });

          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      this.setState({ redirect: true });
    }
  };

  render() {
    const { redirect, allJobs, notification, message, noticolor } = this.state;

    if (redirect) {
      return <Navigate to="/signin" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Blog Categories
              </MDTypography>
            </MDBox>

            <Grid item sm={4} px={2} align="right" mt={2}>
              <Link to="/addBlogCategory">
                <MDButton variant="contained" size="small" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>

            <MDBox p={2}>
              <DataTable
                table={{
                  columns: [
                    { Header: "Serial", accessor: "serial", width: "6%" },
                    { Header: "Category", accessor: "name" },
                    { Header: "Action", accessor: "action" },
                  ],
                  rows: (allJobs || []).map((job, index) => ({
                    serial: index + 1,
                    name: job?.category || "-",
                    action: (
                      <>
                        <div>
                          <Link to={`/updateBlogCategory/${job._id}`}>
                            <MDButton variant="outlined" size="small" color="success">
                              Update
                            </MDButton>
                          </Link>
                        </div>
                        <div style={{ marginTop: "1rem" }}>
                          <MDButton
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => this.handleDelete(job._id)}
                          >
                            Delete
                          </MDButton>
                        </div>
                      </>
                    ),
                  })),
                }}
              />
            </MDBox>

            <MDSnackbar
              color={noticolor}
              icon="notifications"
              title="AgriQuiz"
              content={message}
              dateTime="Just now"
              open={notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
